export default __webpack_public_path__ + "static/portrait-ddc2e59062c69c15b63161dd7f054daa.png";